import todo from './todo';
import refund from './refund';
import account from './account';
import user from './user';
import appraise from './appraise';
import guide from './guide';
import menu from './menu';
import db from './db';
import travel from './travel';
import complaint from './complaint';
import integrity from './integrity';
import home from './home';
import notice from './notice';
import investment from './investment';
import feedback from './feedback';
import instantMessaging from './instantMessaging';
import itineraryUniversal from './itineraryUniversal';
import privacy from './privacy';

export default {
  todo,
  refund,
  account,
  user,
  appraise,
  guide,
  menu,
  db,
  travel,
  complaint,
  integrity,
  home,
  notice,
  investment,
  feedback,
  instantMessaging,
  itineraryUniversal,
  privacy
};
